import { Box, styled } from "@mui/material"

export const Resizer = styled(Box)({
	width: "7px",
	height: "100%",
	position: "absolute",
	top: "0",
	right: "-4px",
	cursor: "col-resize",
	zIndex: "snackbar",
})
